import { AbstractRefModel } from "./abstract-ref.model";

export class RealtyDealModel extends AbstractRefModel {

}
